import React, { useState } from 'react';
import NutritionTracker from '../components/NutritionTracker';
import { useClientData } from '../hooks/useClientData';

const ClientNutritionPage: React.FC = () => {
  const { clientId, client } = useClientData({
    fetchAppointments: false,
    fetchDietPrograms: false,
    fetchDietitian: false,
  });
  const [selectedDate] = useState<Date>(new Date());

  if (!clientId || !client) {
    return null;
  }

  return (
    <NutritionTracker
      clientId={clientId}
      clientName={`${client.firstName} ${client.lastName}`}
      selectedDate={selectedDate}
      isDietitian={false}
      client={client}
    />
  );
};

export default ClientNutritionPage;
